import { jsx as m } from "react/jsx-runtime";
import g from "bignumber.js";
import { initReactI18next as p } from "react-i18next";
import c from "i18next";
import d from "i18next-icu";
import * as y from "@sentry/react";
import { lazy as h } from "react";
const b = (t) => {
  const e = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/, n = String(t).trim().toLowerCase(), r = n.split("@");
  return e.test(n) && r[0].length <= 64 && r[1].length <= 255;
}, z = (t) => {
  const e = String(t).toLowerCase(), n = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
  return e.length < 2083 && n.test(e);
}, N = (t) => /^[a-zA-Z\d]+[a-zA-Z\d_.-]*$/.test(String(t).toLowerCase()), S = (t) => /^\d+$/i.test(t), P = (t) => S(t) && Number(t) > 0, E = function(e) {
  return typeof e == "number" && isFinite(e);
}, a = (t) => typeof t == "string" || t instanceof String, I = (t) => typeof t == "string" && t.startsWith("0x"), U = (t = {}) => !Object.keys(t).length, k = (t) => /^0x([A-Fa-f\d]{64})$/.test(t), A = (t) => /^@(\w){1,15}$/.test(t), _ = (t) => /^@(\w){4,32}$/.test(t), H = (t) => /^@\w/.test(t), R = (t) => /^[A-Z]{3,4}$/.test(t), w = (t) => typeof t != "object" || Array.isArray(t) || t === null ? {} : Object.fromEntries(
  Object.entries(t).map(([e, n]) => [
    e,
    g.isBigNumber(n) ? n.toString() : n
  ])
);
c.use(d).use(p);
const D = c, o = (t, e, n) => {
  const r = D.t(t, {
    ...w(e),
    nsSeparator: ":::",
    ns: "translation",
    interpolation: { escapeValue: !n, alwaysFormat: !0 }
  });
  return n ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ m("span", { dangerouslySetInnerHTML: { __html: r } })
  ) : r;
}, Z = (t, { minLengthForTruncate: e = 12, firstPartLength: n = 6, lastPartLength: r = 6 } = {}) => {
  if (t) {
    if (t.length <= e)
      return t;
    const s = t.split(""), f = s.slice(0, n).join(""), l = s.slice(s.length - r, s.length).join("");
    return o("common.central-dots", { firstPart: f, lastPart: l });
  }
  return "";
};
function j({
  date: t,
  days: e
}) {
  if (t) {
    const n = new Date(t);
    return new Date(n.setDate(n.getDate() + e));
  }
}
function F({
  date: t,
  hours: e
}) {
  if (t) {
    const n = new Date(t);
    return new Date(n.setHours(n.getHours() + e));
  }
}
function L(t) {
  if (a(t))
    return t.toString();
  if (t?.response?.data?.detail && a(t.response.data.detail))
    return t.response.data.detail;
  if (t instanceof Error)
    return t.toString();
  if (t.message)
    try {
      return JSON.parse(t.message);
    } catch {
      return t.message.toString();
    }
  return typeof t?.error?.message == "string" ? t?.error?.message : t.errors?.[0]?.message ? t.errors[0].message.toString() : o("error.unexpected");
}
function W(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getTime() + e.getTimezoneOffset() * 6e4;
  return t ? Math.floor(n / 1e3) : n;
}
const i = {}, M = (t, e = "group") => {
  const n = `${t}_${e}`;
  if (!i[n]) {
    const r = new Intl.NumberFormat(t)?.formatToParts(100000.1).find((s) => s.type === e)?.value;
    r && (i[n] = r);
  }
  return i[n];
}, q = (t) => {
  t && y.init({
    dsn: t,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: !0
  });
};
function u(t, e) {
  return t === e ? t !== 0 || e !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function J(t, e) {
  if (u(t, e)) return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length) return !1;
  for (let s = 0; s < n.length; s++)
    if (!Object.prototype.hasOwnProperty.call(e, n[s]) || !u(t[n[s]], e[n[s]]))
      return !1;
  return !0;
}
const K = (t) => new Proxy({}, {
  get: (e, n) => {
    if (typeof n == "string")
      return h(
        () => t(n).then((r) => ({
          default: r[n]
        }))
      );
  }
});
export {
  j as addDays,
  F as addHours,
  W as getCurrentTimeUTC,
  L as getErrorMessage,
  M as getLocaleSeparator,
  w as getSafeBNVariables,
  D as i18n,
  U as isEmptyObject,
  I as isHexString,
  S as isInteger,
  P as isIntegerPositive,
  E as isNumber,
  H as isStartsWithAt,
  a as isString,
  k as isValidETHTransaction,
  b as isValidEmail,
  _ as isValidTelegramUsername,
  R as isValidTokenName,
  N as isValidUsername,
  z as isValidWebsiteUrl,
  A as isValidXUsername,
  K as lazily,
  q as sentryInit,
  J as shallowEqual,
  o as tCommon,
  Z as truncateByCenterDots
};
//# sourceMappingURL=index.js.map
